"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WelcomeStep = void 0;
var _components = require("@ori-ui/components");
var _icons = require("@ori-ui/icons");
var _mui = require("@ori-ui/mui");
var _downloadOriflameApp = require("@ori/download-oriflame-app");
var _environment = require("@ori/environment");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _react = require("react");
var _Localization = require("../../Localization");
var _defaultTranslations_simplifiedRegistrationBrandPartner = require("../../constants/defaultTranslations_simplified-registration-BrandPartner");
var _contexts = require("../../contexts");
var _models = require("../../models");
var _utils = require("../../utils");
var _jsxRuntime = require("react/jsx-runtime");
const StyledWelcomeTitle = (0, _mui.styled)(_mui.Typography)(({
  theme
}) => ({
  marginBottom: theme.spacing(4),
  marginTop: theme.spacing(6),
  fontWeight: 'bold'
}));
const WelcomeWrapper = (0, _mui.styled)('div')(({
  theme
}) => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  flexDirection: 'column',
  height: '100%',
  marginTop: theme.spacing(4)
}));
const WelcomeActionButton = (0, _mui.styled)(_components.Button)(({
  theme
}) => ({
  minWidth: '330px',
  marginTop: theme.spacing(8)
}));
const Separator = (0, _mui.styled)('div')(({
  theme
}) => ({
  minWidth: 'calc(100% + 60px)',
  height: 20,
  background: theme.palette.grey[100],
  marginTop: theme.spacing(6)
}));
const VerificationIconSuccess = (0, _mui.styled)(_icons.CheckCircleFilled)(({
  theme
}) => ({
  fontSize: '60px',
  color: theme.palette.primary.main
}));
const WelcomeStep = () => {
  const {
    customerDashboardUrl,
    registrationId
  } = (0, _contexts.useConfiguration)();
  const {
    tenant
  } = (0, _environment.useEnvironment)();
  const {
    isMobileOperatingSystem
  } = (0, _utils.useMobileOperatingSystem)();
  const [isRedirectDisabled, setIsRedirectDisabled] = (0, _react.useState)(false);
  const {
    getTestIdProps
  } = (0, _testidGenerator.default)();
  const {
    virtualPageAnalyticsData: {
      previousStep
    }
  } = (0, _contexts.useVirtualPageAnalyticsData)();
  const handleRedirectToDashboard = () => {
    if (customerDashboardUrl) {
      setIsRedirectDisabled(true);
      window.location.href = customerDashboardUrl;
    }
  };
  (0, _react.useEffect)(() => {
    (0, _utils.virtualPageEventDispatch)('SubmitStep', previousStep, registrationId);
    // eslint-disable-next-line react-hooks/exhaustive-deps -- virtual page event should be fired exacly once, no need to reevaluate
  }, []);
  (0, _react.useEffect)(() => {
    // Reset disabled buttons on back navigation for mobile devices
    const handleLocationChange = () => {
      setIsRedirectDisabled(false);
    };
    window.addEventListener('visibilitychange', handleLocationChange);
    return () => window.removeEventListener('visibilitychange', handleLocationChange);
  }, []);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(WelcomeWrapper, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(VerificationIconSuccess, {}), /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledWelcomeTitle, {
      variant: "h2",
      color: "textPrimary",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Localization.Localization, {
        id: _models.TranslationKey.Welcome_Header,
        defaultMessage: _defaultTranslations_simplifiedRegistrationBrandPartner.defaultTranslations.Welcome_Header
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Typography, {
      variant: "subtitle1",
      color: "textPrimary",
      textAlign: "center",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Localization.Localization, {
        id: _models.TranslationKey.Welcome_Text,
        defaultMessage: _defaultTranslations_simplifiedRegistrationBrandPartner.defaultTranslations.Welcome_Text
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(WelcomeActionButton, {
      variant: "contained",
      color: "primary",
      disabled: isRedirectDisabled,
      onClick: () => handleRedirectToDashboard(),
      ...getTestIdProps('welcome-step-btn-welcome'),
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Localization.Localization, {
        id: _models.TranslationKey.Welcome_Button,
        defaultMessage: _defaultTranslations_simplifiedRegistrationBrandPartner.defaultTranslations.Welcome_Button
      })
    }), isMobileOperatingSystem ? /*#__PURE__*/(0, _jsxRuntime.jsx)(Separator, {}) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)(_downloadOriflameApp.DownloadOriflameApp, {
      mt: 6,
      tenant: tenant,
      title: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Localization.Localization, {
        id: _models.TranslationKey.titleContinueApp,
        defaultMessage: _defaultTranslations_simplifiedRegistrationBrandPartner.defaultTranslations.titleContinueApp
      }),
      oriflameApp: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Localization.Localization, {
        id: _models.TranslationKey.oriflameApp,
        defaultMessage: _defaultTranslations_simplifiedRegistrationBrandPartner.defaultTranslations.oriflameApp
      }),
      oriflameAppInfo: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Localization.Localization, {
        id: _models.TranslationKey.oriflameAppInfo,
        defaultMessage: _defaultTranslations_simplifiedRegistrationBrandPartner.defaultTranslations.oriflameAppInfo
      })
    })]
  });
};
exports.WelcomeStep = WelcomeStep;